export default {
  'call-dispatcher': '致电调度员',
  'error-code': '错误 {code}',
  'dispatcher-hint': '如果您看到此错误，请联系 Rx2Go 调度员',
  400: {
    title: '错误请求',
    description: '您点击的链接似乎存在小问题，我们无法处理您的请求。',
  },
  404: {
    title: '页面未找到',
    description: '您查找的页面可能已被删除、更名或暂时不可用。',
  },
  500: {
    title: '内部服务器错误',
    description: '我们遇到了意外错误。请稍后再试。',
  },
  generic: {
    title: '出了点问题',
    description: '出了点问题',
  },
}
